/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */
import { dashboardReducerConstant } from '../../reducerConstant';

const initialState = {
   dashboardContent: null,
};

const dashboardReducer = (state = initialState, action = {}) => {
   switch (action.type) {
      case dashboardReducerConstant.GET_DASHBOARD_EMBED:
         return {
            ...state,
            dashboardContent: action.value
         };
      default:
         return state;
   }
};

export default dashboardReducer;
